import { ScreenPropSupportConfigOffice } from "~/navigation/Navigation.types";

import { SupportConfigOfficeItem } from "./SupportConfigOffice";

export const SupportConfigOfficeScreen = (
  props: ScreenPropSupportConfigOffice,
) => {
  return <SupportConfigOfficeItem officeId={props.route.params.id} />;
};
